export const SET_FRAMEWORK_NAME = "SET_FRAMEWORK_NAME";
export const SET_IMAGE = "SET_IMAGE";
export const RESET_FRAMEWORK = "RESET_FRAMEWORK";
export const SET_FILTERED_FRAMEWORKS = "SET_FILTERED_FRAMEWORKS";
